'use client';

import '@ui5/webcomponents/dist/Title.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `Title` component is used to display titles inside a page.
 * It is a simple, large-sized text with explicit header/title semantics.
 *
 *
 *
 * __Note__: This is a UI5 Web Component! [Repository](https://github.com/SAP/ui5-webcomponents) | [Documentation](https://sap.github.io/ui5-webcomponents/)
 */
const Title = withWebComponent('ui5-title', ['level', 'size', 'wrappingType'], [], [], []);
Title.displayName = 'Title';
export { Title };